import {
  Aside,
  SidebarNav,
  SidebarProfile,
  SidebarLogout,
  ResponsibleProfile,
} from './components';
import { CreditasLogoHorizontal } from './components';

type SidebarProps = {
  items: any;
  profile?: any;
  expanded?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

const Sidebar = ({
  items,
  profile,
  expanded = false,
  onMouseEnter,
  onMouseLeave,
}: SidebarProps): JSX.Element => {
  return (
    <Aside
      expanded={expanded}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
      data-testid="sidebar-menu"
    >
      <SidebarProfile
        profile={profile}
        expanded={expanded}
        IconShort={<CreditasLogoHorizontal />}
      />
      <SidebarNav items={items} expanded={expanded} />

      <ResponsibleProfile profile={profile} expanded={expanded} />

      <SidebarLogout />
    </Aside>
  );
};

export { Sidebar };
